import React from "react";
import queryString from "query-string";
import { useLocation } from "react-router-dom";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const Content = ({ children }) => <div className="content">{children}</div>;

const Header = ({ children }) => <header>{children}</header>;

const useUrlParams = () => {
  const location = useLocation();
  return queryString.parse(location.search);
};

export { Content, Header, classNames, useUrlParams };
